import { EngineDataPoint } from "./engine-data";

export class DrivetrainSettings {
  maxPower: number;
  minRPM: number;
  maxRPM: number;
  maxPowerRPM: number;
  maxTorque: number;
  topSpeed: number;
  gearCount: number = 5;
  lsdSetting: number = 0;
  torqueDistribution: number = 0;
  finalGearOption: string = 'calc';
  finalGear: number;
  gearRatiosOption: string = 'calc';
  minCornerSpeed: number;
  minCornerSpeedGear: number;
  gearRatios: Record<string, number> = {};
  engineData: Array<EngineDataPoint>;
  ratioAdjuster: number = 80;
}

